import { CustomDashboardDomainSection } from './custom-dashboard-domain/CustomDashboardDomainSection';
import { CustomSupportCenterDomainSection } from './custom-support-center-domain/CustomSupportCenterDomainSection';

const CustomDomain = () => {
  return (
    <div className='space-y-5'>
      <CustomDashboardDomainSection />
      <CustomSupportCenterDomainSection />
    </div>
  );
};

export default CustomDomain;
